import React, { useContext, useState } from 'react';
import { CartContext } from '../context/CartContext';
import { useNavigate, useLocation } from 'react-router-dom';
import DeliveryBy from './DeliveryBy';
import './CartStyles.css';

const Cart = () => {
  const {
    cartItems,
    removeFromCart,
    incrementItem,
    decrementItem,
    calculateTotal,
    getItemCount,
  } = useContext(CartContext);
  const [isCartOpen, setCartOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Toggle the cart visibility
  const toggleCart = () => setCartOpen(!isCartOpen);

  // Close the cart when clicking outside
  const closeCartOnOutsideClick = () => {
    if (isCartOpen) setCartOpen(false);
  };

  const isRestrictedPage = location.pathname === '/' || location.pathname === '/checkout' || location.pathname === '/vendor-dashboard';

  // Return nothing if the current page is restricted
  if (isRestrictedPage) return null;

  return (
    <>
      {/* Overlay to close cart on outside click */}
      {isCartOpen && (
        <div
          onClick={closeCartOnOutsideClick}
          className="cart-overlay"
        ></div>
      )}

      {/* Conditionally Render Cart Icon */}
      {!isRestrictedPage && getItemCount() > 0 && (
        <button
          className={`cart-toggle-btn ${isCartOpen ? 'cart-open' : ''}`}
          onClick={toggleCart}
        >
          <i className="bi bi-basket-fill cart-icon"></i>
          <span className="cart-badge">
            {getItemCount()}
          </span>
        </button>
      )}

      {/* Slide-In Cart Drawer */}
      <div className={`cart-drawer ${isCartOpen ? 'cart-drawer-open' : ''}`}>
        <div className="cart-header">
          <h5 className="cart-title">Your Cart</h5>
          <button
            type="button"
            className="cart-close-btn"
            onClick={toggleCart}
          ></button>
        </div>
        <div className="cart-body">
          {cartItems.length > 0 ? (
            cartItems.map((item) => (
              <div
                key={item._id}
                className="cart-item"
              >
                <img
                  src={item.primaryImage || '/placeholder-image.png'}
                  alt={item.name}
                  className="cart-item-image"
                />
                <div className="cart-item-content">
                  <h6 className="cart-item-title">{item.name}</h6>
                  <p className="cart-item-strain">
                    {item.strain || 'N/A'}
                  </p>
                  <div className="cart-item-quantity">
                    <button
                      className="cart-quantity-btn"
                      onClick={() => decrementItem(item._id)}
                    >
                      -
                    </button>
                    <span className="cart-quantity-value">{item.quantity}</span>
                    <button
                      className="cart-quantity-btn"
                      onClick={() => incrementItem(item._id)}
                    >
                      +
                    </button>
                  </div>
                  {/* Display Sale Price with Original Price Crossed Out */}
                  <p className="cart-item-price">
                    {item.salePrice ? (
                      <>
                        <span className="cart-sale-price">
                          ${item.salePrice.toFixed(2)}
                        </span>
                        <span className="cart-original-price">
                          ${item.price.toFixed(2)}
                        </span>
                      </>
                    ) : (
                      <span className="cart-regular-price">
                        ${item.price.toFixed(2)}
                      </span>
                    )}
                  </p>
                </div>
                <button
                  className="cart-remove-btn"
                  onClick={() => removeFromCart(item._id)}
                >
                  <i className="bi bi-trash"></i>
                </button>
              </div>
            ))
          ) : (
            <p className="cart-empty-message">Your cart is empty.</p>
          )}
          <div>
            {/* Delivery By Component */}
            {cartItems.length > 0 && (
              <DeliveryBy
                logoUrl={cartItems[0].logoUrl}
                dispensaryName={cartItems[0].vendorName}
                vendorId={cartItems[0].vendorId}
                orderType={cartItems[0].orderType}
                onClose={toggleCart}
              />
            )}
          </div>
        </div>

        {/* Cart Footer */}
        {cartItems.length > 0 && (
          <div className="cart-footer">
            <div className="cart-total">
              <span className="cart-total-label">Total: </span>
              <span className="cart-total-value">${calculateTotal().toFixed(2)}</span>
            </div>
            <p className="cart-tax-note">
                All taxes included
            </p>
            <button
              className="cart-checkout-btn"
              onClick={() => {
                toggleCart();
                navigate('/checkout'); // Navigate to checkout page
              }}
            >
              Checkout
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Cart;